export const WIDGET_VERSION = "2.0";

export const isSameCurrentVersion = v => v === WIDGET_VERSION;

export default WIDGET_VERSION;
